import { LitElement, html } from 'lit'
import './testimonial-card.js'

class TestimonialsSection extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    static properties = {
        testimonials: { type: Array }
    }

    constructor() {
        super()
        this.testimonials = [
            {
                name: 'Sarah Chen',
                company: 'TechFlow Inc.',
                role: 'Operations Director',
                quote: 'JigsAI has transformed our workflow completely. What used to take our team hours now happens automatically. We\'ve seen a 300% increase in productivity since implementation.',
                avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b789?w=150&h=150&fit=crop&crop=face'
            },
            {
                name: 'Marcus Rodriguez',
                company: 'StartupLab',
                role: 'Founder & CEO',
                quote: 'As a startup, every minute counts. JigsAI gives us the automation capabilities of a much larger company. It\'s like having a team of assistants working 24/7.',
                avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
            },
            {
                name: 'Dr. Emily Watson',
                company: 'Research Institute',
                role: 'Lead Researcher',
                quote: 'The accuracy and intelligence of JigsAI\'s automation is remarkable. It handles complex data processing tasks with precision that exceeds human capability.',
                avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face'
            },
            {
                name: 'James Park',
                company: 'Global Solutions Ltd.',
                role: 'Project Manager',
                quote: 'JigsAI scales with our business needs perfectly. From small tasks to enterprise-level automation, it handles everything seamlessly.',
                avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            },
            {
                name: 'Lisa Thompson',
                company: 'Creative Agency',
                role: 'Creative Director',
                quote: 'Finally, a tool that understands creative workflows. JigsAI automates the boring stuff so we can focus on what we do best - creating amazing work.',
                avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
            },
            {
                name: 'Alex Kumar',
                company: 'DataTech Corp',
                role: 'CTO',
                quote: 'The integration capabilities are outstanding. JigsAI connected our entire tech stack and created workflows we never thought possible.',
                avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face'
            }
        ]
    }

    render() {
        return html`
            <section class="section-padding bg-white dark:bg-gray-900">
                <div class="container-custom">
                    <!-- Section Header -->
                    <div class="text-center mb-16">
                        <h2 class="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
                            Trusted by 
                            <span class="gradient-text">Industry Leaders</span>
                        </h2>
                        <p class="text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
                            Don't just take our word for it. See what our customers have to say about 
                            their experience with JigsAI automation.
                        </p>
                    </div>

                    <!-- Testimonials Grid -->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        ${this.testimonials.map(testimonial => html`
                            <testimonial-card
                                name="${testimonial.name}"
                                company="${testimonial.company}"
                                role="${testimonial.role}"
                                quote="${testimonial.quote}"
                                avatar="${testimonial.avatar}">
                            </testimonial-card>
                        `)}
                    </div>

                    <!-- Trust indicators -->
                    <div class="mt-20">
                        <p class="text-center text-sm text-gray-500 dark:text-gray-400 mb-8 uppercase tracking-wider font-medium">
                            Trusted by companies of all sizes
                        </p>
                        
                        <!-- Company logos placeholder -->
                        <div class="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-60">
                            <div class="w-32 h-12 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                                <span class="text-gray-500 dark:text-gray-400 font-medium">TechFlow</span>
                            </div>
                            <div class="w-32 h-12 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                                <span class="text-gray-500 dark:text-gray-400 font-medium">StartupLab</span>
                            </div>
                            <div class="w-32 h-12 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                                <span class="text-gray-500 dark:text-gray-400 font-medium">Research Co</span>
                            </div>
                            <div class="w-32 h-12 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                                <span class="text-gray-500 dark:text-gray-400 font-medium">Global Ltd</span>
                            </div>
                            <div class="w-32 h-12 bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center">
                                <span class="text-gray-500 dark:text-gray-400 font-medium">DataTech</span>
                            </div>
                        </div>
                    </div>

                    <!-- Rating summary -->
                    <div class="text-center mt-16">
                        <div class="inline-flex items-center space-x-2 mb-4">
                            ${Array.from({ length: 5 }, () => html`
                                <sl-icon library="fa-solid" name="fa-star" class="text-yellow-400 text-xl"></sl-icon>
                            `)}
                        </div>
                        <p class="text-lg text-gray-600 dark:text-gray-400">
                            <strong>4.9/5</strong> average rating from <strong>2,500+</strong> reviews
                        </p>
                    </div>
                </div>
            </section>
        `
    }
}

customElements.define('testimonials-section', TestimonialsSection)